module.exports = __webpack_public_path__ + "img/logo2-cn.fe007d87.png";